import { render, staticRenderFns } from "./CompHouseCard.vue?vue&type=template&id=435bb11d&scoped=true"
import script from "./CompHouseCard.vue?vue&type=script&lang=js"
export * from "./CompHouseCard.vue?vue&type=script&lang=js"
import style0 from "./CompHouseCard.vue?vue&type=style&index=0&id=435bb11d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_css-loader@6.11.0_webpack@5.109.2_cssnano@5_9a63800378998e5629d80734b7f8cab6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435bb11d",
  null
  
)

export default component.exports